"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reselect = require("reselect");

var blogStateSelector = function blogStateSelector(state) {
  return state.blog;
};

var loadPostsSelector = (0, _reselect.createSelector)(blogStateSelector, function (blog) {
  return blog.loadPosts;
});
var loadPostsSuccessSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.success;
});
var loadPostsIsLoadingSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.isLoading;
});
var loadPostsErrorSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.error;
});
var loadPostsDataSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.data;
});
var loadPostsDataCountSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.data && loadPosts.data.length;
});
var loadPostsMetaSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.meta;
});
var loadPostsMetaHasNextSelector = (0, _reselect.createSelector)(loadPostsSelector, function (loadPosts) {
  return loadPosts.meta && loadPosts.meta.hasNext;
});
var _default = {
  loadPostsSuccessSelector: loadPostsSuccessSelector,
  loadPostsIsLoadingSelector: loadPostsIsLoadingSelector,
  loadPostsErrorSelector: loadPostsErrorSelector,
  loadPostsDataSelector: loadPostsDataSelector,
  loadPostsDataCountSelector: loadPostsDataCountSelector,
  loadPostsMetaSelector: loadPostsMetaSelector,
  loadPostsMetaHasNextSelector: loadPostsMetaHasNextSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map